import { graphql } from '@/gql'
import { DeleteDialog, type Props } from '../delete_dialog'
import { useNavigate } from 'react-router'

const DestroyItemMutation = graphql(`
  mutation DestroyItem($id: ID!) {
    destroyItem(input: { id: $id }) {
      item { id }
      errors { path message }
    }
  }
`)

export const Delete = ({ id, open, setOpen, refetchQueries }: Omit<Props<never>, 'mutation' | 'onSuccess'>) => {
  const navigate = useNavigate()

  return (
    <DeleteDialog
      id={ id }
      mutation={ DestroyItemMutation }
      open={ open }
      refetchQueries={ refetchQueries }
      setOpen={ setOpen }
      onSuccess={ () => navigate('/items') }
    />
  )
}
